// Hook (use-auth.js)
import React, { useState, useEffect, useContext, createContext } from "react";
import {Auth} from "./Firebase";
import {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut as FirebaseSignOut
} from "firebase/auth";

const authContext = createContext();
// Provider component that wraps your app and makes auth object ...
// ... available to any child component that calls useAuth().
export function ProvideAuth({ children }) {
    const auth = useProvideAuth();
    return <authContext.Provider value={auth}>{!auth.loading && children}</authContext.Provider>;
}
// Hook for child components to get the auth object ...
// ... and re-render when it changes.
export const useAuth = () => {
    return useContext(authContext);
};
// Provider hook that creates auth object and handles state
function useProvideAuth() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const signIn = (email, password) => {
        return signInWithEmailAndPassword(Auth, email, password)
            .then((response) => {
                setUser(response.user);
                return response.user;
            });
    };
    const signUp = (email, password) => {
        return createUserWithEmailAndPassword(Auth, email, password)
            .then((response) => {
                setUser(response.user);
                return response.user;
            });
    };
    const signOut = () => {
        return FirebaseSignOut(Auth)
            .then(() => {
                setUser(null);
            });
    };
    // Subscribe to user on mount
    // Because this sets state in the callback it will cause any ...
    // ... component that utilizes this hook to re-render with the ...
    // ... latest auth object.
    useEffect(() => {
        const unsubscribe = Auth.onAuthStateChanged((user) => {
            if (user) {
                setUser(user);
            } else {
                setUser(null);
            }
            if (loading) {
                setLoading(false);
            }
        });
        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, [loading]);
    // Return the user object and auth methods
    return {
        loading,
        user,
        signIn,
        signUp,
        signOut
    };
}